import React, { useState, useCallback } from 'react';
import { theme } from '@factorin/container.macro';

import { translate, LanguageSelector } from 'Modules/core/i18n';
import { Text, Button } from 'Modules/ui';

import styles from './index.module.scss';


const ErrorStack = ({ t, stack }) => {
    const [expanded, setExpanded] = useState(false);
    const toggleExpanded = useCallback(() => setExpanded(e => !e), []);
    return (
        <>
            <Button variant='accent' compact onClick={toggleExpanded} className={styles.expand}>
                {t(expanded ? 'collapse' : 'expand')}
            </Button>
            {expanded && (
                <Text textType='light' component='div' className={styles.stack}>
                    {stack}
                </Text>
            )}
        </>
    );
};

const ErrorRenderer = translate('errorBoundary')(({ t, error }) => (
    <Text component='div' className={styles.errorBoundary}>
        <LanguageSelector classNames={{ languageSelector: styles.languageSelector }} />
        <div className={styles.logo}>
            <theme.logo.Normal />
        </div>
        {t('title')}
        <div className={styles.details}>
            {t('details')}:
            <span className={styles.error}>
                {`${error}`}
            </span>
            {error.stack && <ErrorStack t={t} stack={error.stack} />}
        </div>
    </Text>
));

export class ErrorBoundaryMiddleware extends React.PureComponent {
    state = {
        error: null,
    };

    componentDidCatch(error) {
        this.setState({ error });
    }

    render() {
        const { error } = this.state;
        if (error)
            return <ErrorRenderer error={error} />;

        const Component = this.props.Next;
        return <Component />;
    }
}
